import React, { Component } from 'react'
import './styles.scss'
import { withTranslation } from 'react-i18next'
import DefaultLayout from '../../../Layout/Default'
import Box from '../../../../Shared/Box'
import { Col, Container, Row } from '../../../../Shared/Grid'
import Loader from '../../../../Shared/Loader'
import Alert from '../../../../Shared/Alert'
import EmployeeForm from '../Shared/EmployeeForm'
import { adminGetEmployee, adminGetEmployeeSalesTokens, adminPutEmployee } from '../../../../../api'
import SalesTokensList from '../Shared/SalesTokensList'

class EmployeeEditPage extends Component {

  constructor (props) {
    super(props)
    this.state = {
      loading: false,
      employee: null,
      salesTokens: [],
      error: null,
      initialized: false
    }
    this.abortController = null

  }

  componentDidMount () {
    this.fetchAll(this.props.match.params.id)
  }

  fetchAll (employeeId) {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    const promises = Promise.all(
      [adminGetEmployee(employeeId, this.abortController).fetchPromise,
        adminGetEmployeeSalesTokens(employeeId, this.abortController).fetchPromise]
    )

    this.setState({ loading: true, error: null }, () => {
      promises.then((responses) => {
        this.setState(
          {
            loading: false, employee: responses[0],
            salesTokens: responses[1],
            initialized: true
          }
        )
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed to get informations' })
      })
    })
  }

  componentWillUnmount () {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
  }

  onSave = (employee) => {
    if (this.abortController !== null) {
      this.abortController.abort()
    }
    this.abortController = new AbortController()
    this.setState({ loading: true, error: null }, () => {
      adminPutEmployee(employee.id, employee, this.abortController).fetchPromise.then(() => {
        this.fetchAll(employee.id)
      }).catch(() => {
        this.setState({ loading: false, error: 'Failed to save employee' })
      })
    })
  }

  onCancel = () => {
    this.props.history.push('/admin/sales/employees')
  }

  onSalesTokensChange = (tokens) => {
    this.setState({ salesTokens: tokens })
  }

  render () {
    const { t } = this.props

    return (
      <DefaultLayout>
        <div className="employeeEditPage">
          <Box style={{ position: 'relative' }} hasInnerBackground={true}>
            <Container fluid gutterWidth={5}>
              {this.state.loading && <Loader size={32}/>}
              <Row style={{ marginTop: '15px' }}>
                <Col xs={12}>
                  <h3>{t('EDIT_SALES_EMPLOYEE')}</h3>
                </Col>
              </Row>
              {this.state.error && <Alert type={'danger'}>{this.state.error}</Alert>}
              {this.state.initialized && <Row>
                <Container style={{ flex: 1 }} fluid gutterWidth={5}>
                  <Row>
                    <Col xs={12}>
                      <EmployeeForm employee={this.state.employee} onSave={this.onSave} saveLabel={t('SAVE')}
                                    cancelLabel={t('CANCEL')} onCancel={this.onCancel}/>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12}>
                      <SalesTokensList tokens={this.state.salesTokens} onChange={this.onSalesTokensChange}/>
                    </Col>
                  </Row>
                </Container>
              </Row>}
            </Container>
          </Box>
        </div>
      </DefaultLayout>
    )
  }
}

export default withTranslation()(EmployeeEditPage)
